const ContentTypeAlertsTriggers = {
    Periodically: 1,
    OnDocumentCreation: 2,
    OnNewDocumentVersion: 3,
};
export default ContentTypeAlertsTriggers;
